var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onboarding-screen__button", on: { click: _vm.openPanel } },
    [
      _c("CompassIcon", {
        staticClass: "onboarding-screen__button--icon",
        attrs: { icon: "custom-checks", size: "large" }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass:
            "onboarding-screen__button--label typographies-paragraph-small-semibold"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$l10n.__("Commencer avec Sellsy")) +
              "\n    "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }